<div mat-dialog-content>
  <lemon-dialog-header>
    {{ 'change.otsikko' | translate | async }}
  </lemon-dialog-header>

  <div style="padding: 0 1em 0 2em">
    <form novalidate style="width: 100%">
      @if (!success()) {
        <div>
          @if (commonError()) {
            <div class="red-text common-error">{{ commonError() }}</div>
          }
          <mat-form-field>
            <mat-label>{{ 'change.oldpassword' | translate | async }}</mat-label>
            <input #oldpasswordInput type="password" [formField]="lomake.oldpassword" autocomplete="current-password" matInput />
            <i matPrefix class="fa fa-lock fa-kuva" aria-hidden="true"></i>
            @if (onkoVirhe(lomake.oldpassword, 'required') && onkoMuokattuTaiKosketettu(lomake.oldpassword)) {
              <mat-error>{{ 'change.validation.oldpassword.required' | translate | async }}</mat-error>
            }
            @if (onkoVirhe(lomake.oldpassword, 'wrongpassword') && onkoMuokattuTaiKosketettu(lomake.oldpassword)) {
              <mat-error>{{ 'change.validation.oldpassword.wrong-password' | translate | async }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'change.newpassword' | translate | async }}</mat-label>
            <input type="password" [formField]="lomake.newpassword" autocomplete="new-password" matInput />
            <i matPrefix class="fa fa-lock fa-kuva" aria-hidden="true"></i>
            @if (onkoVirhe(lomake.newpassword, 'required') && onkoMuokattuTaiKosketettu(lomake.newpassword)) {
              <mat-error>{{ 'change.validation.newpassword.required' | translate | async }}</mat-error>
            }
          </mat-form-field>
          <div class="vihjeet">
            <div [class.oikein]="!virheet().number && !virheet().required" [class.green-text]="!virheet().number && !virheet().required">{{ 'reset.validation.number' | translate | async }}</div>
            <div [class.oikein]="!virheet().lettersmall && !virheet().required" [class.green-text]="!virheet().lettersmall && !virheet().required">{{ 'reset.validation.lettersmall' | translate | async }}</div>
            <div [class.oikein]="!virheet().letterbig && !virheet().required" [class.green-text]="!virheet().letterbig && !virheet().required">{{ 'reset.validation.letterbig' | translate | async }}</div>
            <div [class.oikein]="!virheet().differentchars && !virheet().required" [class.green-text]="!virheet().differentchars && !virheet().required">{{ 'reset.validation.differentchars' | translate | async }}</div>
            <div [class.oikein]="!virheet().min && !virheet().required" [class.green-text]="!virheet().min && !virheet().required">{{ 'reset.validation.min' | translate | async }}</div>
          </div>
        </div>
      }
      @if (success()) {
        <div style="padding: 5px" class="green-text">{{ 'change.onnistui' | translate | async }}</div>
      }
    </form>
  </div>
</div>
<div mat-dialog-actions>
  @if (!success()) {
    <button type="button" class="secondarybutton" mat-button mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</button>
  }
  @if (!success()) {
    <span class="button-spacer"></span>
  }
  @if (!success()) {
    <button type="button" class="primarybutton" mat-button (click)="changePassword()">{{ 'change.vaihda' | translate | async }}</button>
  }
  @if (success()) {
    <button type="button" class="primarybutton" mat-button mat-dialog-close>{{ 'yleiset.ok' | translate | async }}</button>
  }
</div>
